import type { StatusColor } from '@uiKit/components/StatusBadge.vue'
import {
  TREASURY_BANK_ACCOUNT_STATUS,
  type TreasuryBankAccountStatus,
} from '../types/treasuryAccountsTypes'

const STATUS_COLOR: Record<TreasuryBankAccountStatus, StatusColor> = {
  [TREASURY_BANK_ACCOUNT_STATUS.ACTIVE]: 'success',
  [TREASURY_BANK_ACCOUNT_STATUS.INACTIVE]: 'neutral',
  [TREASURY_BANK_ACCOUNT_STATUS.ARCHIVED]: 'neutral',
}

const STATUS_LABEL: Record<TreasuryBankAccountStatus, string> = {
  [TREASURY_BANK_ACCOUNT_STATUS.ACTIVE]: 'Active',
  [TREASURY_BANK_ACCOUNT_STATUS.INACTIVE]: 'Inactive',
  [TREASURY_BANK_ACCOUNT_STATUS.ARCHIVED]: 'Archived',
}

export function getTreasuryAccountStatusColor(status: TreasuryBankAccountStatus): StatusColor {
  return STATUS_COLOR[status] ?? 'neutral'
}

export function getTreasuryAccountStatusLabel(status: TreasuryBankAccountStatus): string {
  return STATUS_LABEL[status] ?? status
}
